import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { Provider } from "react-redux"
import { ThemeProvider } from '@mui/material/styles'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import countries from "i18n-iso-countries"
import * as Sentry from '@sentry/react'

import { store } from './store'
import { initAnalytics } from './core/analytics'
import theme from './theme'

import './18n'
import '../src/assets/styles/reset.css'
import '../src/assets/styles/fonts.css'
import '../src/assets/styles/global.css'
import '../src/assets/styles/maplibre-gl.css'
import 'react-image-gallery/styles/css/image-gallery.css'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://6a59c5cf0d61fe8984b0335250a65c9e@o4512038705430528.ingest.us.sentry.io/4512038727385088',
    environment: process.env.NODE_ENV,
  })
}

initAnalytics()

countries.registerLocale(require("i18n-iso-countries/langs/en.json"))

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ToastContainer/>
        <Sentry.ErrorBoundary fallback={<p>Что-то пошло не так. Обновите страницу.</p>}>
          <App />
        </Sentry.ErrorBoundary>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
